import React from 'react';
import { motion } from 'framer-motion';
import { FileText, BookOpen, Key, CreditCard, Smartphone } from 'lucide-react';
const includes = [{
  icon: <FileText className="w-10 h-10 text-navy" data-id="element-173" />,
  title: '1. El Inventario Maestro de Activos Digitales',
  description: 'Tu hoja de ruta principal. Un documento claro donde anotarás qué cuentas tienes, dónde están y por qué son importantes.'
}, {
  icon: <BookOpen className="w-10 h-10 text-navy" data-id="element-174" />,
  title: "2. Plantilla de 'Instrucciones de Emergencia'",
  description: 'Una carta guiada para tus herederos. Diles exactamente a quién contactar y qué hacer primero, sin dejarlos con dudas.'
}, {
  icon: <Key className="w-10 h-10 text-navy" data-id="element-175" />,
  title: "3. Organizador de Contraseñas 'Analógico-a-Digital'",
  description: 'Un sistema seguro en papel para anotar tus claves de forma que solo tu familia pueda entenderlas, lejos de los hackers.'
}, {
  icon: <CreditCard className="w-10 h-10 text-navy" data-id="element-176" />,
  title: '4. Registro de Suscripciones Ocultas',
  description: 'Evita que sigan cobrando a tu tarjeta meses después. Una lista fácil para cancelar pagos automáticos rápidamente.'
}];
export function WhatsIncluded() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-navy text-cream" data-id="element-177">
      <div className="max-w-6xl mx-auto" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-179">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold mb-6" data-id="element-180">
            Todo lo que necesitas, en un formato fácil de leer
          </h2>
          <p className="text-xl text-cream-dark max-w-3xl mx-auto" data-id="element-181">
            Diseñado con letra grande, alto contraste y lenguaje sencillo. Nada
            de términos informáticos complicados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-182">
          {includes.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream text-navy p-8 rounded-2xl flex flex-col sm:flex-row gap-6 items-start" data-id="element-183">
              <div className="bg-gold/20 p-4 rounded-xl shrink-0" data-id="element-184">
                {item.icon}
              </div>
              <div data-id="element-185">
                <h3 className="text-2xl font-bold mb-3" data-id="element-186">{item.title}</h3>
                <p className="text-lg text-navy-light" data-id="element-187">{item.description}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gold text-navy-dark p-8 md:p-10 rounded-2xl border-4 border-gold-light flex flex-col md:flex-row items-center gap-8" data-id="element-188">
          <div className="bg-white p-5 rounded-full shrink-0 shadow-md" data-id="element-189">
            <Smartphone className="w-12 h-12 text-gold-dark" data-id="element-190" />
          </div>
          <div data-id="element-191">
            <h3 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-192">
              INCLUYE GUÍA PASO A PASO: Configuración de Contacto Legado
            </h3>
            <p className="text-xl" data-id="element-193">
              Te enseñamos con imágenes grandes cómo decirle a tu iPhone, Google
              y Facebook quién debe tener acceso a tus cuentas si tú ya no
              estás. ¡En menos de 10 minutos!
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}